<template>
  <div id="department_tab"
       class="main-tab main-tab-o">
    <div class="dv-content">
      <img src="../assets/images/icon_ks_bg.png"
           class="img-ks-bg">
      <div class="dv-content-s">
        <div class="tv-title">用心提供一流的医疗服务</div>
        <div class="dv-content-item">
          <div class="dv-left">
            <div class="tv-ks-title">科室</div>
            <div class="ks-list">
              <el-tree :data="kslist"
                       :props="defaultProps"
                       @node-click="handleNodeClick"
                       :default-expanded-keys="expandedkey"
                       node-key="id"
                       ref="myTree"
                       :current-node-key="currentkey"
                       :highlight-current="highlightCurrent"></el-tree>
            </div>
          </div>
          <div class="dv-right">
            <div class="tv-ks-name">{{ newsinfo.departname }}</div>
            <div class="dv-ks-detail">
              <el-image :src="newsinfo.fileUrl"
                        class="img-ks"
                        v-if="newsinfo.fileUrl"
                        fit="cover">
                <el-image slot="error"
                          class="img-ks"
                          src="../assets/images/icon_nodata.png"></el-image>
              </el-image>
              <div class="dv-ks-details">
                <div class="dv-name-item">姓名 &nbsp;&nbsp;&nbsp;{{ newsinfo.name }}</div>
                <div class="dv-name-item">职务 &nbsp;&nbsp;&nbsp;{{ newsinfo.duties }}</div>
                <div class="dv-name-item">职称 &nbsp;&nbsp;&nbsp;{{ newsinfo.title }}</div>
              </div>

            </div>
            <div class="dv-fwb">
              <div class="tv-html"
                   v-html="newsinfo.content"></div>

            </div>
          </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import api from '../api/api'
const aes = require('../utils/aes.js')
export default {
  data () {
    return {
      // 711F5F8B-0FF9-43E7-924F-41BE3800A03C
      kslist: [],
      expandedkey: [],
      currentkey: '',
      checkedkeys: [],
      defaultProps: {
        label: 'name',
        children: 'departList',
      },
      newsinfo: '',//详情数据
      fid: '',
      zid: '',
    }
  },
  props: {
    highlightCurrent: {
      type: Boolean,
      default: true,
    }
  },
  created () {
    //科室列表
    const fid = this.$route.query.fid
    if (fid) {
      this.fid = this.$route.query.fid
      this.zid = this.$route.query.zid
    }
    this.getCategorylist()

  },
  methods: {
    //切换科室
    handleNodeClick (e, data) {
      console.log(e)
      if (data.level == 2) {
        // console.log("handleNodeClick", e, data);
        this.currentkey = e.id
        this.departdetail(this.currentkey)
      }



    },

    //获取科室列表
    getCategorylist () {
      let parm = {
        FKEY: api.getFKEY(),
        currentPage: 1,
        showCount: 100
      }
      api.departcategorylist(parm).then((res) => {
        this.kslist = res.data.list
        if (this.fid == '') {
          var array = []
          array.push(res.data.list[0].id)
          this.expandedkey = array
          this.currentkey = res.data.list[0].departList[0].id
          this.$nextTick(() => {
            this.$refs['myTree'].setCurrentKey(this.currentkey)
          })
        } else {
          var array = []
          array.push(this.fid)
          this.expandedkey = array
          this.currentkey = this.zid
          this.$nextTick(() => {
            this.$refs['myTree'].setCurrentKey(this.currentkey)
          })
        }

        this.departdetail(this.currentkey)
      })
    },
    //科室详情
    departdetail (departid) {
      let parm = {
        FKEY: api.getFKEY(),
        departid: aes.Encrypt(departid)
      }
      api.departdetail(parm).then((res) => {
        this.newsinfo = res.data

      })
    },

  },

}
</script>

<style>
.dv-content {
  width: 100%;
  height: fit-content;
  display: flex;
  position: relative;
  flex-direction: column;
}
.img-ks-bg {
  position: absolute;
  /* top: 40px; */
  left: 0;
  width: 100%;
}
.dv-content-s {
  width: calc(100% - 600px);
  height: fit-content;
  margin-left: 300px;
  margin-top: 40px;
  display: flex;
  flex-direction: column;
}
.tv-title {
  font-size: 32px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  margin-top: 50px;
  color: #ffffff;
}
.dv-content-item {
  width: 100%;

  height: fit-content;
  margin-top: 50px;
  display: flex;
  flex-direction: row;
}
.dv-left {
  width: 300px;
  height: 800px;
  display: flex;
  flex-direction: column;
  background: url("../assets/images/icon_ks_left.png");
}
.dv-right {
  display: flex;
  width: calc(100% - 300px);
  background: white;
  flex-direction: column;
}
.tv-ks-name {
  font-size: 28px;
  margin: 20px 0 0 20px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  text-align: left;
  color: #333333;
}
.dv-ks-detail {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 20px;
  align-items: center;
  background: #edf0f8;
  display: flex;
  flex-direction: row;
  height: 200px;
}
.img-ks {
  width: 300px;
  height: 100%;
}
.dv-ks-details {
  display: flex;
  margin-left: 40px;
  flex-direction: column;
}
.dv-name-item {
  font-size: 22px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: left;
  margin-bottom: 20px;
  color: #333333;
}
.tv-ks-title {
  font-size: 30px;
  font-family: Alimama ShuHeiTi, Alimama ShuHeiTi-Bold;
  font-weight: 700;
  margin-left: 70px;
  margin-top: 20px;
  text-align: left;
  color: #593e2a;
}
.ks-list {
  margin-top: 40px;
  /* margin-left: 32px; */
  overflow: scroll;
  padding-bottom: 40px;
}
.el-tree {
  background: #00000000 !important;
}
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #d2b37c !important;
  color: #ffffff !important;
  padding-left: 40px !important;
}
.is-current {
  color: #ffffff !important;
}

.el-tree-node__content:hover {
  background: #d2b37c !important;
  /* opacity: 0.5; */
}
.el-tree-node__content {
  height: 60px !important;
  padding-left: 40px !important;
  color: #593e2a;
}
.el-tree-node__expand-icon {
  color: #593e2a !important;
}
.is-leaf {
  color: #00000000 !important;
}
.el-tree-node:focus > .el-tree-node__content {
  background-color: #d2b37c !important;
}
.el-tree-node__label {
  font-size: 20px !important;
  /* color: #593e2a; */
}

.dv-fwb {
  width: calc(100% - 40px);
  margin-left: 20px;
  margin-top: 20px;
  min-height: 800px;
}
.tv-html {
  width: calc(100% - 40px);
  margin: 20px 0 20px 0 20px;
  margin-bottom: 20px;
  text-align: left;
}
.el-icon-caret-right:before {
  content: "\27A4" !important;
  /* font-size: 1rem !important; */
}
.el-icon-d-arrow-right::before {
  content: "\00BB" !important;
  font-size: 1.2rem !important;
}
.el-icon-d-arrow-left::before {
  content: "\00AB" !important;
  font-size: 1.2rem !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #634d91 !important;
  color: #fff !important;
}
.el-pager li:not(.disabled):hover {
  color: #634d91 !important;
  background: white !important;
}
.el-pager li:not(.disabled) {
  background: white !important;
  border: 2px solid #beb1e5 !important;
}
.btn-next {
  padding: 0 10px 0 10px !important;
  border: 2px solid #beb1e5 !important;
  background: white !important;
}
.btn-prev {
  padding: 0 10px 0 10px !important;
  background: white !important;
  border: 2px solid #beb1e5 !important;
}
</style>